/**
 * Created by lency on 9/1/16.
 */
export default () => {
    return function (scope, elem) {
        elem.on('focus', 'input', function () {
            elem.addClass('active');
        });

        elem.on('blur', 'input', function () {
            elem.removeClass('active');
        });
    };
};



// WEBPACK FOOTER //
// ./src/app/components/face/index/user/input-group.directive.js